export const AddCircleIcon = ({ color = "#FFFFFF", size = 17, ...props }) => (
    <svg
        width={size}
        height={size * (16 / 17)}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <line x1="13.2998" y1="8.19679" x2="3.6998" y2="8.19679" stroke={color} strokeWidth="1.03226" />
        <line x1="8.30418" y1="12.8008" x2="8.30418" y2="3.20078" stroke={color} strokeWidth="1.03226" />
        <circle cx="8.5" cy="8" r="7.48387" transform="rotate(90 8.5 8)" stroke={color} strokeWidth="1.03226" />
    </svg>
);
